import {initImageDesktopGalleries, initImageMobileGalleries} from './image-gallery';
import {initMediaThumbnailsCarousels} from './product';
import {initProductCarousels, initRelatedProductCarousels} from './product-carousel';
import {intProductCustomization} from './product-customization';

document.addEventListener("DOMContentLoaded", function () {
    initProductCarousels();
    initImageDesktopGalleries();
    initImageMobileGalleries();
    initMediaThumbnailsCarousels();
    intProductCustomization();
});

document.addEventListener("ProductRecommendationsLoaded", function () {
    initRelatedProductCarousels();
})